// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"636633b0","193":"acbd2a85","537":"ce92ac8e","647":"5f7fb1bf","658":"f40cb50a","817":"40bc7d63"}[chunkId] + ".chunk.js";
};